import React from "react";
import { Glyphicon } from "react-bootstrap";
import { useUtilityStyles } from "../hooks/useUtilityStyles";
import { classNames } from "../utils/classNames";
import { useModalTitleClasses } from "./Title.styles";
export const TYPE_GLYPHS = {
    info: "info-sign",
    warning: "exclamation-sign",
    warningWithoutCancel: "exclamation-sign",
    success: "ok",
    error: "remove-sign",
};
export const Title = ({ type, title, titleType, styleOptions }) => {
    const TitleElement = titleType === "header" ? "h1" : "span";
    const classes = useModalTitleClasses(type, titleType === "span");
    const utilityStyles = useUtilityStyles(styleOptions);
    return (React.createElement("div", { className: classNames(utilityStyles.utilities, classes.wrapper) },
        type && React.createElement(Glyphicon, { className: classes.icon, glyph: TYPE_GLYPHS[type] }),
        React.createElement(TitleElement, { className: classes.title, "data-hook": "modal-title" }, title)));
};
